import React, { useEffect, useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Section, Link, Image, SearchBar, SideNav, BlogButton } from 'newComponents'
import search from '../../../images/blog/search.svg'

import './styles.scss'

const BlogNav = () => {
  // get all categories
  const categoriesData = useStaticQuery(graphql`
    query categories {
      categoryList: prismicSettings {
        data {
          blog_navigation_links {
            link_text {
              html
              text
            }
            link_url {
              url
            }
          }
        }
      }
    }
  `)

  // format categories
  const { categoryList } = categoriesData
  const { data } = categoryList
  const { blog_navigation_links: categories } = data
  // state
  const [displaySearch, setDisplaySearch] = useState(false)
  const [stickNav, setStickNav] = useState(false)
  const [showSideNav, setShowSideNav] = useState(false)

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, true)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [stickNav, displaySearch])

  useEffect(() => {
    const nextSection = document.querySelector('.blog-nav+section')
    if (stickNav) {
      nextSection.style.paddingTop = `106px`
    } else {
      nextSection.style.paddingTop = '0px'
    }
  }, [stickNav])

  const handleScroll = () => {
    const scrollPosition = window.scrollY
    const headerElement = document.querySelector('.header-nav')
    const { clientHeight: navDistanceFromTop } = headerElement
    const stickNavAt = navDistanceFromTop

    if (scrollPosition > stickNavAt && !stickNav) {
      setStickNav(true)
    }

    if (scrollPosition < stickNavAt && stickNav) {
      setStickNav(false)
      // Handle open search UI changes when user reaches top of page
      setDisplaySearch(false)
    }
  }

  const handleShowSearch = (event) => {
    if (event) event.preventDefault()
    const headerElement = document.querySelector('.header-nav')
    const blogNavElement = document.querySelector('.blog-nav')
    const blogNavHeight = blogNavElement.offsetHeight
    if (displaySearch) {
      headerElement.style.marginBottom = 0
      setDisplaySearch(false)
    } else {
      headerElement.style.marginBottom = `${blogNavHeight}px`
      setDisplaySearch(true)
    }
  }

  const handleShowSideNav = (event) => {
    if (event) event.preventDefault()
    setShowSideNav(true)
  }

  const handleCloseSideNav = (event) => {
    if (event) event.preventDefault()
    setShowSideNav(false)
  }

  const searchVisible = displaySearch ? 'show-search' : 'hide-search'
  const demoButtonVisible = stickNav ? '' : 'hide-demo-button'
  const stickNavClass = stickNav ? 'stick-nav' : ''

  return (
    <Section className={`blog-nav ${searchVisible} ${stickNavClass}`}>
      {!displaySearch && (
        <div className="blog-nav-container">
          {/* LOGO ON LEFT */}
          <Link className="blog-nav-home" to="/blog">
            <span className="blog-nav-home-text full-text">LaunchDarkly Blog</span>
            <span className="blog-nav-home-text short-text">Blog</span>
          </Link>
          {/* CATEGORIES/LINKS */}
          <div className="blog-nav-categories">
            {categories.map((item, index) => {
              const { link_text: linkText, link_url: to } = item
              return (
                <Link
                  to={`/blog/category${to.url}`}
                  className="blog-nav-post-category"
                  key={linkText.text}
                  style={{ animationDelay: `${index * 0.15}s` }}
                >
                  {linkText.text}
                </Link>
              )
            })}
            <Link to="#showmore" className="blog-nav-post-category show-more" onClick={handleShowSideNav}>
              More
            </Link>
          </div>
          {/* SEARCH BUTTON */}
          <button className="blog-nav-search-button" type="button" onClick={handleShowSearch}>
            <Image className="blog-nav-search-icon search" image={search} />
          </button>
          <BlogButton removeBlogPath to="/request-a-demo" className={`blog-nav-demo-button ${demoButtonVisible}`}>
            Get Demo
          </BlogButton>
        </div>
      )}
      <section className="blog-nav-search-container">
        {displaySearch && (
          <SearchBar className="blog-nav-searchbar" active={displaySearch} closeSearch={handleShowSearch} />
        )}
      </section>
      {/* MOBILE SIDE NAV */}
      <SideNav active={showSideNav} handleClose={handleCloseSideNav}>
        <div className="blog-nav-aside">
          <div className="blog-nav-aside-header">
            <span className="blog-nav-aside-logo">
              <span className="blog-nav-aside-logo-text">LaunchDarkly Blog</span>
            </span>
            <button className="blog-nav-aside-close" type="button" onClick={handleCloseSideNav}>
              Close
            </button>
          </div>
          <div className="blog-nav-aside-links">
            {/* LINKS */}
            {categories.map((item, index) => {
              const { link_text: linkText, link_url: to } = item
              return (
                <Link
                  to={`/blog/category${to.url}`}
                  className="blog-nav-aside-link"
                  key={linkText.text}
                  style={{ animationDelay: `${index * 0.15}s` }}
                >
                  {linkText.text}
                </Link>
              )
            })}
          </div>
        </div>
      </SideNav>
    </Section>
  )
}

export default BlogNav
